<template>

  <CommonPublicView>
    <template v-slot:header>
      
      <div class="w-full flex flex-row py-6 text-white font-bold uppercase text-2xl [text-shadow:_2px_2px_0_rgb(155_155_155_/_60%)]">
        <div v-if="evento">{{evento.descripcion}}</div>
      </div>

    </template>
    <template v-slot:content>
      
      <div class="container w-full mx-auto">

        <!-- FORM CARD -->
        <div class="relative w-full shadow-lg rounded-lg bg-white p-4">
          <div class="flex items-center justify-between font-semibold text-lg ">
            CATÁLOGO 
          </div>

          <div class="container mx-auto block w-full mt-4 space-y-4">

            <CatalogoView :padding="false" />

          </div>

        </div>
        <!-- FORM CARD -->

      </div>
      

    </template>
  </CommonPublicView>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import CommonPublicView from '@/components/commons/CommonPublicView.vue';

import suiteConfig from '@/services/suite.config';
import { Evento } from 'qreventos-suite/src/services/suite.interfaces';

import seguridadServices from '@/services/seguridad.services';
import eventoServices from 'qreventos-suite/eventos';

import CatalogoView from "@/components/views/CatalogoView.vue";

export default defineComponent({
  components: {
    CommonPublicView, CatalogoView
  },
  created() {
    document.title = "Catálogo";
  },
  data() {
    return {
      evento: undefined as unknown as Evento
    };
  },
  async mounted() {
    try {
      eventoServices.clientId = suiteConfig.clientId;
      eventoServices.token = suiteConfig.token;

      const idEvento:number = Number(this.$route.params.id);
      if(idEvento) {
        this.evento = await eventoServices.validarEvento(idEvento);
      }

    }
    catch (error) {
      Swal.fire({ title: "Error", text: 'Sesión expirada [' + error + ']', icon: "error" })
        .then(() => {
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        });
    }    
  }
});
</script>
